'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.BootstrapFeatures', []).service('BootstrapFeaturesService', require('./services/BootstrapFeaturesService'));